import React from "react";
import Hero from "../../assets/course-thumbnail.png";
import { Link } from "react-router-dom";
import AgeIcon from "../../assets/age-group.png";
import ClockIcon from "../../assets/clock.png";
const CampsCourses = () => {
  const outcomes = [
    "Learn basic coding",
    "Make games and animations",
    "Get creative with digital tools",
  ];
  return (
    <div className="bg-white">
      <div className="max-w-[1920px] mx-auto pt-[90px] pb-20">
        <h1 className="font-bold leading-[47px] text-[40px] text-center mb-[73px]">
          Choose from personalized Summer Coding Camps for your child
        </h1>
        <div className="grid grid-cols-4 gap-y-12  gap-x-6 px-24">
          {Array.from({ length: 8 }).map((_, index) => (
            <div className="bg-white rounded-[18px] shadow-[0px_0px_9.8px_1px_rgba(0,0,0,0.25)]">
              <img src={Hero} alt="Hero" className="w-full h-auto" />
              <div className="pl-6 text-black">
                <h2 className="mt-[30px]  text-xl leading-[23px] font-bold ">
                  Scratch Explorer: <br /> Foundations of Coding
                </h2>
                <div className="mt-6 flex items-center gap-3 leading-[19px] font-normal">
                  <img src={AgeIcon} alt="age" className="w-4 h-4" />
                  <p>Ages 7-10 years</p>
                </div>
                <div className="mt-[10px] flex items-center gap-3 leading-[19px] font-normal">
                  <img src={ClockIcon} alt="duration" className="w-4 h-4" />
                  <p>6 x 45-minute Sessions</p>
                </div>
                <p className="mt-6 max-w-[368px]  leading-[19px] font-normal">
                  Designed to enhance problem-solving with animation and game
                  creation.
                </p>
                <h3 className="font-medium mt-5 mb-3">Learning outcomes</h3>
                {outcomes.map((itm, idx) => (
                  <p className="leading-[19px]" key={idx}>
                    {itm}
                  </p>
                ))}
              </div>

              <div className="px-6 mt-8 mb-4">
                <Link
                  to={`/camps/camps-registration`}
                  className="bg-[#FF6636] hover:bg-transparent font-bold text-white hover:text-[#FF6636] hover:border hover:border-[#FF6636] rounded-[18px] leading-[19px] py-[16.5px] w-full flex items-center justify-center"
                >
                  Claim your Spot
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CampsCourses;
